const REWARD_TYPE = 'ui.general.reward_one'

class LoyaltyHistoryTable extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.initialLoad = true
    this.tab = 'rewards'
  }

  connectedCallback () {
    super.connectedCallback()

    this.observer = new MutationObserver(() => {
      this.apply()
    })

    this.observer.observe(this.els.table.element, {
      childList: true,
      subtree: true,
    })

    this.apply()
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    this.observer?.disconnect()
  }

  setupListeners () {
    super.setupListeners()

    this.els.tab.elements.forEach((tab) => {
      this.listeners.add(tab, 'click', this.onTabClick.bind(this))
    })
  }

  onTabClick (event) {
    const nextTab = event.currentTarget.dataset.tab

    if (nextTab !== 'rewards' && nextTab !== 'activity') return

    this.tab = nextTab

    this.els.tab.elements.forEach((tab) => {
      tab.setAttribute(
        'aria-selected',
        tab.dataset.tab === this.tab ? 'true' : 'false',
      )
    })

    this.apply()
  }

  apply () {
    const table = this.els.table.element.querySelector('table')

    if (!table) {
      this.setEmpty(false)
      return
    }

    this.setColumnLabel(table)

    const rows = table.querySelectorAll('tbody tr')
    let visible = 0

    rows.forEach((row) => {
      const typeCell = row.querySelector(':scope > td[data-i18n-key]')
      const isReward = typeCell?.getAttribute('data-i18n-key') === REWARD_TYPE
      const show = typeCell && (this.tab === 'rewards' ? isReward : !isReward)

      row.hidden = !show

      if (show) visible += 1
    })

    this.setEmpty(visible === 0)
  }

  setColumnLabel (table) {
    const header = table.querySelector('th[data-i18n-key="ui.general.action"]')

    if (!header || header.textContent.trim() === this.columnLabel) return

    header.textContent = this.columnLabel
  }

  setEmpty (isEmpty) {
    const table = this.els.table.element.querySelector('table')
    const empty = this.els.empty.element

    empty.hidden = !isEmpty

    if (!isEmpty) {
      table.style.display = ''
    } else {
      if (this.initialLoad) {
        this.initialLoad = false
        this.autoSwitchTab('activity')
      }

      table.style.display = 'none'
      empty.textContent = this.emptyLabel
    }
  }

  autoSwitchTab (tabName) {
    if (tabName !== 'rewards' && tabName !== 'activity') return

    this.tab = tabName

    this.els.tab.elements.forEach((tab) => {
      tab.setAttribute(
        'aria-selected',
        tab.dataset.tab === this.tab ? 'true' : 'false',
      )
    })

    this.apply()
  }

  get columnLabel () {
    return this.tab === 'rewards'
      ? this.dataset.rewardsColumn
      : this.dataset.activityColumn
  }

  get emptyLabel () {
    return this.tab === 'rewards'
      ? this.dataset.rewardsEmpty
      : this.dataset.activityEmpty
  }
}

if (!customElements.get('loyalty-history-table')) {
  customElements.define('loyalty-history-table', LoyaltyHistoryTable)
}
